// extracted by mini-css-extract-plugin
export default {"trigger":"_pgRF","visible":"xG8rQ","arrow":"SsaUm","popup":"Hdx79","containerLabel":"A6vBj","label":"VjsCY"};